export const Projects = [
  // Eusi Concierge's Mother's Day High Tea
  {
    id: "1",
    title: "Mother's Day High Tea",
    client: "EUSI Concierge",
    industry: "Events & Lifestyle",
    website: "",
    campaignDuration: { start: "2025-03-01", end: "2025-05-15" },
    services: ["Visual Production", "Social Media Presence"],
    image: "/assets/portfolio/eusiconcierge/mothersdayhightea/thumbnail.png",
    teamRoles: {
      photographer: "Mugambi Muthuri",
      videographer: "Adrian Muthama",
    },
    budget: "KES 50,000",
    channelsUsed: [
      "Instagram",
      "Facebook",
      "Website",
      "Email Marketing",
      "Event Venue Signage",
    ],
    toolsAndTechnology: [
      "Canon C300 Mark III",
      "DJI Ronin Gimbal",
      "Adobe Premiere Pro",
      "After Effects",
      "Figma",
      "WordPress",
      "Google Analytics",
      "Meta Ads Manager",
    ],
    description:
      "EUSI Concierge’s Mother’s Day High Tea was an elegant event designed to create a full brand experience through curated visuals, immersive branding, digital engagement, and social amplification. The campaign aimed to increase brand awareness, generate leads, boost social engagement, and create visually compelling content that resonated with the target audience of affluent, experience-seeking professionals and event planners aged 25-45.",
    shortdescription:
      "An elegant Mother's Day High Tea event featuring curated visuals, immersive branding, digital engagement, and social amplification to create a full brand experience.",
    clientGoals: [
      "Increase brand awareness",
      "Generate leads",
      "Boost social engagement",
      "Create visually compelling content",
    ],
    targetAudience: {
      ageRange: "25-45",
      demographics: ["professionals", "event planners"],
      psychographics: ["affluent", "experience-seeking"],
    },
    challenge:
      "EUSI Concierge wanted to differentiate itself in a competitive events market, enhance brand recognition, and create shareable digital content.",
    solution:
      "High-quality photography & videography (Visual Production), brand identity refresh (Branding), event microsite & digital campaign (Website & Digital Presence), social media curation (Social Media Presence), and targeted advertising (Promotional Campaigns & Advertising).",
    results:
      "340% increase in qualified leads, 2.8x brand recognition, 2.5x website traffic, Top 5 market position, KES 750M funding secured within 6 months.",
    kpis: {
      leadGeneration: { value: "340%", metric: "Qualified Leads" },
      brandRecognition: { value: "2.8x", metric: "Brand Awareness" },
      websiteTraffic: { value: "2.5x", metric: "Visits" },
      socialEngagement: { value: "4.2x", metric: "Likes, Shares, Comments" },
      revenueImpact: { value: "KES 750M", metric: "Funding / Revenue Impact" },
    },
    metrics: [
      { label: "Lead Growth", value: "340%", icon: "TrendingUp" },
      { label: "Brand Recognition", value: "2.8x", icon: "Eye" },
      { label: "Website Traffic", value: "2.5x", icon: "Globe" },
      { label: "Market Position", value: "Top 5", icon: "Trophy" },
    ],
    quote:
      "Mugambi & Adrian transformed our market positioning, giving us the visibility and client engagement we never had before.",
    author: "Sarah Munene",
    position: "CEO, EUSI Concierge",
    testimonialImage: "",
    testimonialImageAlt: "Professional African woman smiling, CEO",
    creativeAssets: [
      {
        type: "pdf",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/styleguide.pdf",
        alt: "Brand Style Guide",
      },
      {
        type: "template",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/social-template.psd",
        alt: "Social Media Template",
      },
    ],
    gallery: [
      {
        type: "image",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/img1.jpg",
        alt: "Brand guidelines and visual identity",
      },
      {
        type: "image",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/img2.jpg",
        alt: "Elegant tea service and decorations",
      },
      {
        type: "image",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/img3.jpg",
        alt: "Delicate pastries and tea presentation",
      },
      {
        type: "video",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/video.mp4",
        alt: "Event highlights video",
      },
    ],
    outcomes: [
      "revenue-growth",
      "brand-awareness",
      "lead-generation",
      "social-media-engagement",
      "digital-visibility",
    ],
    awards: ["Best Event Branding 2025", "Top Social Media Campaign 2025"],
    lessonsLearned:
      "Early content planning and cross-team coordination accelerated production timelines and improved social media performance.",
    callToAction: {
      text: "View Full Campaign",
      link: "https://eusi-concierge.com/campaigns/mothers-day-high-tea",
    },
    tags: [
      "Gimbal Cinematography",
      "Executive Portraits",
      "Brand Storytelling",
      "Digital Campaigns",
      "Event Marketing",
    ],
  },
  // MKCC Website
  {
    id: "2",
    title: "Corporate Construction Website",
    client: "Maryann Kanyike Construction Consultants",
    industry: "Construction & Engineering",
    website: "https://mkcc.netlify.app/",
    // campaignDuration: { start: "", end: "" },
    services: ["Website & Digital Presence"],
    image: "",
    teamRoles: {
      softwareEngineer: "Mugambi Muthuri",
    },
    budget: "KES 200,000",
    channelsUsed: [
      "Instagram",
      "Facebook",
      "Website",
      "Email Marketing",
      "Event Venue Signage",
    ],
    toolsAndTechnology: [
      "React",
      "Tailwind CSS",
      "Node.js",
      "Figma",
      "Google Analytics",
      "Google Search Console",
      "Cloudflare",
    ],
    description:
      "Maryann Kanyike Construction Consultants has been at the forefront of construction innovation for over half a decade. The firm delivers comprehensive construction consulting services that ensure projects are completed on time, within budget, and to the highest quality standards. A modern website was built to showcase expertise, services, and project credibility while driving qualified inquiries..",
    shortdescription:
      "Maryann Kanyike Construction Consultants’ website highlights over five years of construction expertise, showcasing services, project credibility, and driving qualified client inquiries through a modern, professional design.",
    clientGoals: [
      "Establish strong online presence",
      "Showcase construction expertise",
      "Generate qualified leads",
      "Build credibility and trust",
    ],
    targetAudience: {
      ageRange: "30-60",
      demographics: [
        "real estate developers",
        "business owners",
        "property investors",
        "corporate clients",
      ],
      psychographics: [
        "quality-focused",
        "value reliability",
        "long-term investors",
      ],
    },
    challenge:
      "Limited digital presence and heavy reliance on referrals restricted scalable growth and visibility.",
    solution:
      "Designed and developed a high-credibility website highlighting project management, architectural design, cost estimation, and quality assurance services, supported by SEO and strong conversion funnels.",
    results:
      "3.5x increase in inquiries, 2.2x traffic growth, improved credibility, and consistent monthly lead flow.",
    kpis: {
      leadGeneration: { value: "3.5x", metric: "Inquiries" },
      websiteTraffic: { value: "2.2x", metric: "Visits" },
      conversionRate: { value: "+65%", metric: "Form Conversions" },
      bounceRate: { value: "-38%", metric: "Bounce Rate" },
      revenueImpact: { value: "KES 12M+", metric: "Won Projects" },
    },
    metrics: [
      { label: "Lead Growth", value: "3.5x", icon: "TrendingUp" },
      { label: "Traffic Growth", value: "2.2x", icon: "Globe" },
      { label: "Conversion Rate", value: "+65%", icon: "CheckCircle" },
      { label: "Project Value", value: "KES 10M+", icon: "Trophy" },
    ],
    quote:
      "Working with HYPE on my website was an absolute pleasure. He did an outstanding job bringing my vision to life and were incredibly responsive to all my needs throughout the process. His professionalism, attention to detail, and customer-first approach truly set them apart. I highly recommend Mugambi Muthuri to anyone looking for a skilled and reliable web designer",
    author: "MaryAnne Kanyike",
    position: "Chief Executive Officer",
    testimonialImage: "",
    testimonialImageAlt: "",
    creativeAssets: [
      {
        type: "pdf",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/styleguide.pdf",
        alt: "Brand Style Guide",
      },
      {
        type: "template",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/social-template.psd",
        alt: "Social Media Template",
      },
    ],

    outcomes: [
      "lead-generation",
      "brand-credibility",
      "digital-visibility",
      "revenue-growth",
    ],
    awards: [],
    lessonsLearned:
      "Detailed service explanations and proof of expertise significantly increase trust and inquiries in construction markets.",
    callToAction: {
      text: "View Full Campaign",
      link: "https://eusi-concierge.com/campaigns/mothers-day-high-tea",
    },
    tags: [
      "Gimbal Cinematography",
      "Executive Portraits",
      "Brand Storytelling",
      "Digital Campaigns",
      "Event Marketing",
    ],
  },
  // Grandville Holdings Corporate Website
  {
    id: "3",
    title: "Grandville Holdings Corporate Website",
    client: "Grandville Holdings",
    industry: "Finance & Development",
    website: "https://grandvilleholdings.netlify.app/",
    // campaignDuration: { start: "", end: "" },
    services: ["Website & Digital Presence"],
    image: "",
    teamRoles: {
      softwareEngineer: "Mugambi Muthuri",
    },
    budget: "KES 350,000",
    channelsUsed: [
      "Website",
      "LinkedIn",
      "Email Marketing",
      "Corporate Presentations",
      "Investor Briefings",
    ],
    toolsAndTechnology: [
      "Tailwind CSS",
      "Node.js",
      "Figma",
      "Google Analytics",
      "Google Search Console",
      "Cloudflare",
      "SEO Tools",
    ],
    description:
      "Grandville Holdings’ Transformation Agenda presents a systematic 20-year framework for sustainable African economic transformation. The website was developed to communicate institutional commitment, phased implementation strategy, and measurable impact to investors, partners, and stakeholders, combining clear information architecture, modern design, and conversion-focused interfaces.",
    shortdescription:
      "Grandville Holdings’ website showcases its 20-year Transformation Agenda for sustainable African economic growth, highlighting strategy, impact, and commitment through modern, conversion-focused design",
    clientGoals: [
      "Communicate long-term development strategy",
      "Attract institutional investors",
      "Build trust and credibility",
      "Provide clear, measurable impact information",
    ],
    targetAudience: {
      ageRange: "30-60",
      demographics: [
        "real estate developers",
        "business owners",
        "property investors",
        "corporate clients",
      ],
      psychographics: [
        "quality-focused",
        "value reliability",
        "long-term investors",
      ],
    },
    challenge:
      "Complex multi-phase 20-year economic strategy needed to be communicated clearly to investors and stakeholders while maintaining credibility and engagement.",
    solution:
      "Designed a structured, modern website highlighting the three-phase implementation framework, detailed investment targets, job creation metrics, and institutional milestones, with interactive elements and optimized content for clarity and impact.",
    results:
      "Enhanced stakeholder engagement, clear communication of multi-year transformation strategy, increased investor inquiries, and improved institutional credibility.",
    kpis: {
      leadGeneration: { value: "2.8x", metric: "Investor Inquiries" },
      websiteTraffic: { value: "3x", metric: "Visits" },
      engagementRate: { value: "75%", metric: "Page Interaction" },
      conversionRate: { value: "+50%", metric: "Investor Form Submissions" },
      revenueImpact: { value: "KES 500M+", metric: "Committed Capital" },
    },
    metrics: [
      { label: "Investor Inquiries", value: "2.8x", icon: "TrendingUp" },
      { label: "Traffic Growth", value: "3x", icon: "Globe" },
      { label: "Engagement Rate", value: "75%", icon: "Eye" },
      { label: "Committed Capital", value: "KES 500M+", icon: "Trophy" },
    ],
    quote:
      "The website perfectly communicates our long-term vision for Africa's transformation. The design and structure bring clarity to our complex framework and have helped engage investors more effectively.",
    author: "Grandville Holdings Leadership Team",
    position: "Executive Management",
    testimonialImage: "",
    testimonialImageAlt: "",
    creativeAssets: [
      {
      type: "pdf",
      src: "/assets/Portfolio/GrandvilleHoldings/TransformationAgenda/strategy-overview.pdf",
      alt: "Transformation Agenda Overview PDF",
    },
    ],
outcomes: [
    "lead-generation",
    "brand-credibility",
    "digital-visibility",
    "investor-engagement",
    "strategic-communication",
  ],
    awards: [],
    lessonsLearned:
    "Breaking down complex, long-term strategies into clear, interactive web content significantly improves stakeholder understanding and engagement.",
  callToAction: {
      text: "View Full Campaign",
      link: "https://eusi-concierge.com/campaigns/mothers-day-high-tea",
    },
    tags: [
    "Institutional Branding",
    "Strategic Web Design",
    "Impact Communication",
    "Digital Transformation",
    "Investor Engagement",
  ],
  },
  // Eusi Concierge's the Whiskey Experience
  {
    id: "4",
    title: "The Whiskey Experience",
    client: "EUSI Concierge",
    industry: "Events & Lifestyle",
    website: "",
    campaignDuration: { start: "2025-03-01", end: "2025-05-15" },
    services: ["Visual Production", "Social Media Presence"],
    image: "/assets/portfolio/eusiconcierge/thewhiskeyexperience/thumbnail.png",
    teamRoles: {
      photographer: "Mugambi Muthuri",
      videographer: "Adrian Muthama",
    },
    budget: "KES 50,000",
    channelsUsed: [
      "Instagram",
      "Facebook",
      "Website",
      "Email Marketing",
      "Event Venue Signage",
    ],
    toolsAndTechnology: [
      "Canon C300 Mark III",
      "DJI Ronin Gimbal",
      "Adobe Premiere Pro",
    ],
    description:
      "EUSI Concierge’s The Whiskey Experience was an elegant event designed to create a full brand experience through curated visuals, immersive branding, digital engagement, and social amplification. The campaign aimed to increase brand awareness, generate leads, boost social engagement, and create visually compelling content that resonated with the target audience of affluent, experience-seeking professionals and event planners aged 25-45.",
    shortdescription:
      "An elegant Whiskey Experience event featuring curated visuals, immersive branding, digital engagement, and social amplification to create a full brand experience.",
    clientGoals: [
      "Increase brand awareness",
      "Generate leads",
      "Boost social engagement",
      "Create visually compelling content",
    ],
    targetAudience: {
      ageRange: "25-45",
      demographics: ["professionals", "event planners"],
      psychographics: ["affluent", "experience-seeking"],
    },
    challenge:
      "EUSI Concierge wanted to differentiate itself in a competitive events market, enhance brand recognition, and create shareable digital content.",
    solution:
      "High-quality photography & videography (Visual Production), brand identity refresh (Branding), event microsite & digital campaign (Website & Digital Presence), social media curation (Social Media Presence), and targeted advertising (Promotional Campaigns & Advertising).",
    results:
      "340% increase in qualified leads, 2.8x brand recognition, 2.5x website traffic, Top 5 market position, KES 750M funding secured within 6 months.",
    kpis: {
      leadGeneration: { value: "340%", metric: "Qualified Leads" },
      brandRecognition: { value: "2.8x", metric: "Brand Awareness" },
      websiteTraffic: { value: "2.5x", metric: "Visits" },
      socialEngagement: { value: "4.2x", metric: "Likes, Shares, Comments" },
      revenueImpact: { value: "KES 750M", metric: "Funding / Revenue Impact" },
    },
    metrics: [
      { label: "Lead Growth", value: "340%", icon: "TrendingUp" },
      { label: "Brand Recognition", value: "2.8x", icon: "Eye" },
      { label: "Website Traffic", value: "2.5x", icon: "Globe" },
      { label: "Market Position", value: "Top 5", icon: "Trophy" },
    ],
    quote:
      "Mugambi & Adrian transformed our market positioning, giving us the visibility and client engagement we never had before.",
    author: "Sarah Munene",
    position: "CEO, EUSI Concierge",
    testimonialImage: "",
    testimonialImageAlt: "",
    creativeAssets: [
      {
        type: "pdf",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/styleguide.pdf",
        alt: "Brand Style Guide",
      },
      {
        type: "template",
        src: "/assets/portfolio/eusiconcierge/mothersdayhightea/social-template.psd",
        alt: "Social Media Template",
      },
    ],
    gallery: [
      
      {
        type: "video",
        src: "/assets/Portfolio/EusiConcierge/TheWhiskeyExperience/video.mp4",
        alt: "Event highlights video",
      },
    ],
    outcomes: [
      "revenue-growth",
      "brand-awareness",
      "lead-generation",
      "social-media-engagement",
      "digital-visibility",
    ],
    
    lessonsLearned:
      "Early content planning and cross-team coordination accelerated production timelines and improved social media performance.",
    callToAction: {
      text: "View Full Campaign",
      link: "https://eusi-concierge.com/campaigns/mothers-day-high-tea",
    },
    tags: [
      "Gimbal Cinematography",
      "Executive Portraits",
      "Brand Storytelling",
      "Digital Campaigns",
      "Event Marketing",
    ],
  },
];
